import type { StorageFormat } from '../../storage.types';
import { isValidDateISOString } from './isValidDateISOString';

const DATE_PREFIX = '__DATE__';

export const formatForStorage = (value: unknown) => {
  const item: StorageFormat<typeof value> = { value };

  return JSON.stringify(item, (_, entry) => {
    // You might think that entry here would be a Date and one could simply do "entry instanceof Date",
    // but actually it will be a string already (no idea why JSON.stringify does this)
    if (isValidDateISOString(entry)) {
      return `${DATE_PREFIX}${entry}`;
    }

    return entry;
  });
};

export const parseFromStorage = <T>(value: string): StorageFormat<T> | null => {
  try {
    const parsed = JSON.parse(value, (_, entry) => {
      if (typeof entry === 'string' && entry.startsWith(DATE_PREFIX)) {
        return new Date(entry.slice(DATE_PREFIX.length));
      }

      return entry;
    }) as StorageFormat<T>;

    return parsed;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return null;
  }
};
